import React, {Component} from 'react';
import MaterialIcon from '../../../../MaterialIcon';

class PanelNavigation extends Component {
    render(){
        return (
            <nav className="panel-navigation">
                <button onClick={()=>this.props.selectedMenu('newNodes')} className={this.props.tabData.newNodes ? 'navigation-button active' : 'navigation-button'} disabled={this.props.isReadOnly}>
                    <MaterialIcon icon="add_box" />
                    <span>New Node</span>
                </button>
                <button onClick={()=>this.props.selectedMenu('versionHistory')} className={this.props.tabData.versionHistory ? 'navigation-button active' : 'navigation-button'} disabled={this.props.isReadOnly}>
                    <MaterialIcon icon="history" />
                    <span>Versions</span>
                </button>
                {/* <button onClick={()=>this.props.selectedMenu('finder')} className={this.props.tabData.finder ? 'navigation-button active' : 'navigation-button'}>
                    <MaterialIcon icon="search" />
                    <span>Finder</span>
                </button>
                <button onClick={()=>this.props.selectedMenu('version')} className={this.props.tabData.version ? 'navigation-button active' : 'navigation-button'}>
                    <MaterialIcon icon="call_split" />
                    <span>Version</span>
                </button>
                <button onClick={()=>this.props.selectedMenu('usages')} className={this.props.tabData.usages ? 'navigation-button active' : 'navigation-button'}>
                    <MaterialIcon icon="format_indent_increase" />
                    <span>Usages</span>
                </button>
                <button onClick={()=>this.props.selectedMenu('context')} className={this.props.tabData.context ? 'navigation-button active' : 'navigation-button'}>
                    <MaterialIcon icon="language" />
                    <span>Context</span>
                </button>
                <button onClick={()=>this.props.selectedMenu('variables')} className={this.props.tabData.variables ? 'navigation-button active' : 'navigation-button'}>
                    <MaterialIcon icon="tune" />
                    <span>Variables</span>
                </button> */}
            </nav>
        )
    }
}

export default PanelNavigation;